<aside class="nf-drawer" [class.nf-drawer--beside-list]="besideList">
    <!-- The card stretches to the height of the list beside it, so the two end level. This holds
         the content at the top of the viewport as that list scrolls past, rather than letting it
         scroll away and leave the pane empty. -->
    <div class="nf-drawer__sticky">
        <div class="nf-drawer__header">
            <div class="nf-drawer__heading">
                @if (eyebrow) {
                <span class="nf-drawer__eyebrow">{{ eyebrow }}</span>
                }
                <span
                    class="nf-drawer__title"
                    [class.nf-drawer__title--mono]="titleMono"
                    [title]="titleTail ? title + titleTail : title"
                    >{{ title }}@if (titleTail) {<span class="nf-drawer__title-tail">{{ titleTail }}</span>}</span
                >
            </div>

            <div class="nf-drawer__actions">
                <!-- Pages through the rows already loaded, in the order they are shown, so the
                     panel follows whatever the reader sorted to. -->
                @if (showPager) {
                <div class="nf-drawer__pager">
                    <button
                        type="button"
                        class="nf-drawer__pager-btn"
                        id="DetailDrawerPrev"
                        [disabled]="!hasPrev"
                        (click)="navigate(-1)"
                        title="Previous"
                        aria-label="Previous"
                    >
                        <svg
                            viewBox="0 0 24 24"
                            width="16"
                            height="16"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true"
                        >
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                    </button>
                    <span class="nf-drawer__pager-count"
                        >{{ index + 1 }}<span class="nf-drawer__pager-sep">/</span
                        ><span class="nf-drawer__pager-total">{{ total }}</span></span
                    >
                    <button
                        type="button"
                        class="nf-drawer__pager-btn"
                        id="DetailDrawerNext"
                        [disabled]="!hasNext"
                        (click)="navigate(1)"
                        title="Next"
                        aria-label="Next"
                    >
                        <svg
                            viewBox="0 0 24 24"
                            width="16"
                            height="16"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2.25"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            aria-hidden="true"
                        >
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </button>
                </div>
                }
                <button
                    type="button"
                    class="nf-drawer__close"
                    id="DetailDrawerClose"
                    (click)="close()"
                    aria-label="Close"
                >
                    &times;
                </button>
            </div>
        </div>

        <!-- Full-bleed to the card's inner edges, so the selected tab's underline reads as the
             top edge of the pane below it rather than as a line floating in the header. -->
        @if (showTabs) {
        <div class="nf-drawer__tabs" role="tablist" aria-label="Detail">
            @for (pane of tabs; track pane.id) {
            <button
                type="button"
                class="nf-drawer__tab"
                id="DetailDrawerTab{{ pane.id }}"
                role="tab"
                [class.selected]="tab === pane.id"
                [attr.aria-selected]="tab === pane.id"
                (click)="selectTab(pane.id)"
            >
                {{ pane.label }}
            </button>
            }
        </div>
        }

        <!-- What this row is. The only part that differs between one listing and the next. -->
        <div class="nf-drawer__body">
            <ng-content></ng-content>
        </div>
    </div>
</aside>
